<template>
    <div
        v-clipboard:copy="copyText"
        v-clipboard:success="copyHandlerSuccess"
        v-clipboard:error="copyHandlerError"
        class="flex-inline cursor-help rounded-sm p-0 text-[0.6rem] text-slate-100"
        :title="t('copyToClipboard')"
    >
        <div
            :class="[
                config.env.name.startsWith('DEV') ? 'bg-rose-700' : 'bg-indigo-700',
                'inline rounded-l-md py-1 pr-1 pl-2',
            ]"
        >
            <span>{{ config.env.name }}</span> /
            <span v-if="config.env.docker">Docker</span>
            <span v-else>Native</span>
        </div>
        <div class="inline bg-green-600 px-1 py-1">{{ config.version }}</div>
        <div class="inline rounded-r-md bg-cyan-700 py-1 pr-2 pl-1">
            {{ config.env.tz }} UTC+{{ -config.env.tzOffset / 60 }}
        </div>
    </div>
</template>

<script setup>
    import { inject } from 'vue';
    import { notify } from 'notiwind';
    import { t } from '../composables/i18n';

    defineExpose({
        name: 'BuildBadge',
    });

    const config = inject('config');

    const copyText = `${config.env.name} / ${config.env.docker ? 'Docker' : 'Native'} ${
        config.version
    } ${config.env.tz} UTC+${-config.env.tzOffset / 60}`.trim();

    const copyHandlerSuccess = async () => {
        notify(
            {
                group: 'info',
                title: t('copiedToClipboard'),
                text: copyText,
            },
            1770,
        );
    };
    const copyHandlerError = async () => {
        notify(
            {
                group: 'error',
                title: t('Error'),
                text: copyText,
            },
            2500,
        );
    };
</script>
